import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

export type ModalType = 'success' | 'error' | 'info' | 'alert';

export interface ModalSecondButton {
  text: string;
  onClick: () => void;
}

export interface ModalConfig {
  type: ModalType;
  title: string;
  description: string;
  buttonText: string;
  showCloseButton?: boolean;
  onButtonClick?: () => void;
  secondButton?: ModalSecondButton;
}

@Component({
  selector: 'app-modal',
  imports: [CommonModule, MatIcon, MatDialogModule],
  templateUrl: './modal.html',
})
export class ModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public config: ModalConfig,
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'success-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/check_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'error-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/error_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'info-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/info_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'alert-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/alert_icon.svg'),
    );
  }

  onButtonClick(): void {
    this.dialogRef.close();
    this.config.onButtonClick?.();
  }

  onSecondButtonClick(): void {
    this.dialogRef.close();
    this.config.secondButton?.onClick();
  }

  getIconColor(): string {
    switch (this.config.type) {
      case 'success':
        return '#008218';
      case 'error':
        return '#F00444';
      case 'info':
        return '#0D6FFF';
      case 'alert':
        return '#FB9301';
      default:
        return '#0D6FFF';
    }
  }
}
